import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import Icon from "../../assets/Payment/success icon component.svg";
import Button from "../../components/Form/CustomButton";

function PaymentSucessful() {
  useEffect(() => {
    const interval = setInterval(() => {
      confetti({
        particleCount: 40,
        spread: 160,
        origin: { x: Math.random(), y: Math.random() * 0.6 },
      });
    }, 500);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);
  return (
    <>
      <div className="main-container  flex justify-center items-center my-[48px] mx-5 ">
        <div className="inner-content flex flex-col p-[24px] justify-center items-center rounded-[20px] bg-[#fff] shadow-[0px_4px_10px_2px_rgba(211,220,219,0.50)] ">
          <img src={Icon} alt="Success Icon" className="w-20 h-auto" />
          <p className="mt-[24px] mb-[0px] text-primary text-[24px] font-bold font-inter tracking-[0.024px]">
            Payment Successful !
          </p>
          <p className=" text-[#535862] text-[12px] font-inter mt-[8px] mb-[0px]">
            Your payment has been processed successfully.
          </p>
          <div className="flex flex-row space-x-[12px] mt-[24px] justify-center items-center">
            <div className="flex justify-center items-center">
              <p className=" mb-[0px] text-content font-semibold font-inter text-[16px] tracking-[0.016px]">
                Transaction ID
              </p>
            </div>
            <div className="flex justify-center items-center">
              <p className="text-[12px] font-inter font-normal">01247896548</p>
            </div>
          </div>
          <div className="flex flex-row space-x-[12px] mt-[12px] justify-center items-center">
            <div className="flex justify-center items-center">
              <p className=" mb-[0px] text-content font-semibold font-inter text-[16px] tracking-[0.016px]">
                Amount Paid
              </p>
            </div>
            <div className="flex justify-center items-center">
              <p className="text-[12px] font-inter font-normal">$250.00</p>
            </div>
          </div>

          <div className="mt-[80px] flex flex-row  gap-[24px] w-full justify-center items-center">
            <div className="left-line border-t-2 border-[#CBD5E0] w-full "></div>
            <div className="flex justify-center items-center rounded-[16px] border-[1px] border-primary bg-[rgba(224, 242, 241, 0.30)] px-[16px] py-[8px] text-[#4A4A4A] text-[12px] font-inter w-full text-center bg-customBg ">
              What`s Next
            </div>
            <div className="left-line border-t-2 border-[#CBD5E0] w-full "></div>
          </div>

          <div className="mt-[32px] flex flex-row gap-[12px] flex-wrap justify-center">
            <div>
              <Button
                buttonText="Go to My Posts"
                className="lg:px-[75px] px-[20px] py-[16px] text-[14px]"
                width="0"
              />
            </div>
            <div>
              <Button
                buttonText="Go to Chat"
                className="lg:px-[75px] px-[20px]  py-[16px] text-[14px]"
                width="0"
              />
            </div>
            <div>
              <Button
                buttonText="Order Details"
                className="lg:px-[75px] px-[20px] py-[16px] text-[14px]"
                width="0"
              />
            </div>
          </div>

          <button>
            <p className="mt-[24px] text-primary text-[14px] font-semibold font-inter">
              Back to Dashboard
            </p>
          </button>
        </div>
      </div>
    </>
  );
}

export default PaymentSucessful;
